import { ALL_TEAMS } from 'common/constants/teams';
import { PERMISSION_SCOPE_TYPE } from '@linearb/linjs-common';

const TEAM_SCOPES = [
  PERMISSION_SCOPE_TYPE.TEAM,
  PERMISSION_SCOPE_TYPE.ALL_TEAMS
];

const resolveTeamNameAndTooltip = ({ teams, teamScopes }) => {
  const TEAM_NAMES_TO_DISPLAY = 3;
  const JOINER = ', ';
  const teamIds = teamScopes.map(({ scope_id }) => scope_id);
  const teamNames = teams
    .filter(({ id }) => teamIds.includes(id))
    .map(({ name }) => name);
  const { length: teamCount } = teamNames;
  const tooltip =
    teamCount > TEAM_NAMES_TO_DISPLAY ? teamNames.join(JOINER) : '';
  const name =
    teamCount <= TEAM_NAMES_TO_DISPLAY
      ? teamNames.join(JOINER)
      : `${teamNames.slice(0, TEAM_NAMES_TO_DISPLAY).join(JOINER)}, +${
          teamCount - TEAM_NAMES_TO_DISPLAY
        }...`;
  return { tooltip, name };
};

export const getTeamScopes = accountScopes =>
  accountScopes.filter(({ scope_type }) => TEAM_SCOPES.includes(scope_type));

export const accountScopesToTeamsColumnValues = ({ accountScopes, teams }) => {
  const allTeamsValue = { name: ALL_TEAMS.name, tooltip: '' };
  const noScopesValue = { name: 'No assigned teams', tooltip: '' };
  if (!accountScopes) {
    return noScopesValue;
  }
  const teamScopes = getTeamScopes(accountScopes);

  if (!teamScopes.length) {
    return noScopesValue;
  }
  const isScopeAllTeams = !!teamScopes.filter(
    ({ scope_type }) => scope_type === PERMISSION_SCOPE_TYPE.ALL_TEAMS
  ).length;
  return isScopeAllTeams
    ? allTeamsValue
    : resolveTeamNameAndTooltip({ teams, teamScopes });
};
